// Mock data for ddt interiors website

export const companyInfo = {
  name: "DDT INTERIORS",
  nameChinese: "點點點設計",
  tagline: "Connecting every single dot between you and your visionary space",
  taglineChinese: "以細節定義空間，讓設計超越時間",
  slogan: "點點點都有態度 · EVERY DOT HAS A STORY",
  coreValues: "Design, Details, Timeless",
  coreValuesChinese: "設計 · 細節 · 雋永",
  phone: "+852 6991 3856",
  email: "ddt@ddtinteriors.com",
  whatsapp: "85269913856",
  address: "荃灣W 212",
  addressEnglish: "W 212, Tsuen Wan",
  googleMapsUrl: "https://www.google.com/maps/search/?api=1&query=荃灣W+212",
  description: "頂級空間設計與品牌提案，源自極致美學、精密工藝與100%透明化承諾",
  descriptionEn: "Premium space design and brand proposals, derived from ultimate aesthetics, precision craftsmanship and 100% transparency commitment"
};

export const categories = [
  {
    id: "office",
    name: "辦公室",
    nameEn: "Office",
    slug: "office",
    description: "商務總部美學與極致高效運作，整合「開放協同」與「高級隱密」雙重商務理念",
    icon: "Briefcase"
  },
  {
    id: "clinic",
    name: "診所",
    nameEn: "Clinic",
    slug: "clinic",
    description: "專業醫療空間規劃，100% 符合香港衛生署規範，防交叉感染與人文關懷設計",
    icon: "Stethoscope"
  },
  {
    id: "beauty",
    name: "美容",
    nameEn: "Beauty",
    slug: "beauty",
    description: "極致私密與沉浸式五感療癒，打造具備完全隔音屏障的專業級美容空間",
    icon: "Sparkles"
  },
  {
    id: "retail",
    name: "零售",
    nameEn: "Retail",
    slug: "retail",
    description: "沉浸式奢華零售空間，運用戲劇化光影與黃金人流引導，提升提袋率與客單價",
    icon: "ShoppingBag"
  },
  {
    id: "pickleball",
    name: "匹克球運動",
    nameEn: "Pickleball",
    slug: "pickleball",
    description: "專業壁網球體育會所，嚴格遵循 USA Pickleball 官方競賽標準，融合運動與商務社交",
    icon: "Trophy"
  }
];

export const projects = [
  {
    id: 1,
    title: "Central Executive Office",
    titleChinese: "中環工業風簡約辦公室",
    category: "office",
    description: "An industrial-style minimalist office in Central featuring concrete finishes, exposed ceilings, glass partitions, and sophisticated furniture. Combines raw industrial aesthetics with modern functionality.",
    descriptionChinese: "位於中環的工業風簡約辦公室，融合裸露天花、混凝土飾面、玻璃隔間與精緻家具，展現原始工業美學與現代機能的完美結合。",
    image: "https://customer-assets-wrfwihn1.emergentagent.net/job_interior-spaces-24/artifacts/gv6ti1w9_1.webp",
    gallery: [
      "https://customer-assets-wrfwihn1.emergentagent.net/job_interior-spaces-24/artifacts/gv6ti1w9_1.webp",
      "https://customer-assets-wrfwihn1.emergentagent.net/job_interior-spaces-24/artifacts/fx38iq1e_2.webp",
      "https://customer-assets-wrfwihn1.emergentagent.net/job_interior-spaces-24/artifacts/l2t6rm80_3.webp",
      "https://customer-assets-wrfwihn1.emergentagent.net/job_interior-spaces-24/artifacts/ymgy2d4z_4.webp",
      "https://customer-assets-wrfwihn1.emergentagent.net/job_interior-spaces-24/artifacts/15wxn3ut_5.webp"
    ],
    year: "2024",
    area: "2,500 sq ft"
  },
  {
    id: 2,
    title: "Modern Tech Hub",
    titleChinese: "現代科技中心",
    category: "office",
    description: "Open-plan workspace designed for collaboration and innovation with integrated technology solutions.",
    descriptionChinese: "為協作和創新而設計的開放式工作空間，配備集成技術解決方案。",
    image: "https://images.unsplash.com/photo-1497366216548-37526070297c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1Mjh8MHwxfHNlYXJjaHwyfHxjb21tZXJjaWFsJTIwaW50ZXJpb3J8ZW58MHx8fHwxNzg0MjUxNDc4fDA&ixlib=rb-4.1.0&q=85",
    year: "2024",
    area: "3,800 sq ft"
  },
  {
    id: 3,
    title: "Wellness Medical Center",
    titleChinese: "健康醫療中心",
    category: "clinic",
    description: "A serene and modern medical facility with curved architectural elements and natural light integration.",
    descriptionChinese: "寧靜而現代的醫療設施，採用曲線建築元素和自然採光。",
    image: "https://images.unsplash.com/photo-1781513144825-aa1e284c5950?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzl8MHwxfHNlYXJjaHwzfHxtb2Rlcm4lMjBjbGluaWMlMjBpbnRlcmlvciUyMGx1eHVyeXxlbnwwfHx8fDE3ODQyNTE0MDZ8MA&ixlib=rb-4.1.0&q=85",
    year: "2024",
    area: "1,800 sq ft"
  },
  {
    id: 4,
    title: "Premier Dental Clinic",
    titleChinese: "專業牙科診所",
    category: "clinic",
    description: "Contemporary dental clinic featuring clean lines, sophisticated lighting, and patient-centered design.",
    descriptionChinese: "當代牙科診所，採用簡潔線條、精緻照明和以患者為中心的設計。",
    image: "https://images.unsplash.com/photo-1782397132123-0166b524d6bc?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzl8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBjbGluaWMlMjBpbnRlcmlvciUyMGx1eHVyeXxlbnwwfHx8fDE3ODQyNTE0MDZ8MA&ixlib=rb-4.1.0&q=85",
    year: "2023",
    area: "1,200 sq ft"
  },
  {
    id: 5,
    title: "TST Beauty Centre",
    titleChinese: "尖沙咀美容中心",
    category: "beauty",
    description: "An elegant beauty centre in Tsim Sha Tsui featuring warm earthy tones, curved architectural elements, natural wood finishes, and sophisticated lighting design creating a serene and luxurious atmosphere.",
    descriptionChinese: "位於尖沙咀的優雅美容中心，運用溫暖大地色調、曲線建築元素、天然木質飾面與精緻燈光設計，營造寧靜奢華的頂級療癒氛圍。",
    image: "https://customer-assets-wrfwihn1.emergentagent.net/job_interior-spaces-24/artifacts/y86lfpkm_Gemini_Generated_Image_i8aeq7i8aeq7i8ae.webp",
    gallery: [
      "https://customer-assets-wrfwihn1.emergentagent.net/job_interior-spaces-24/artifacts/y86lfpkm_Gemini_Generated_Image_i8aeq7i8aeq7i8ae.webp"
    ],
    year: "2024",
    area: "1,500 sq ft"
  },
  {
    id: 6,
    title: "Serenity Spa Retreat",
    titleChinese: "寧靜水療中心",
    category: "beauty",
    description: "Tranquil spa environment designed to promote wellness and rejuvenation through thoughtful spatial planning.",
    descriptionChinese: "寧靜的水療環境，通過周到的空間規劃促進健康和煥發活力。",
    image: "https://images.unsplash.com/photo-1611920630418-f587fdc3bf94?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NDh8MHwxfHNlYXJjaHwzfHxzcGElMjBpbnRlcmlvciUyMGx1eHVyeXxlbnwwfHx8fDE3ODQyNTE0MTh8MA&ixlib=rb-4.1.0&q=85",
    year: "2023",
    area: "2,000 sq ft"
  },
  {
    id: 7,
    title: "Modern Fashion Boutique",
    titleChinese: "現代時尚精品店",
    category: "retail",
    description: "Contemporary retail space with minimalist display systems and strategic lighting to highlight products.",
    descriptionChinese: "當代零售空間，採用極簡展示系統和戰略性照明突出產品。",
    image: "https://images.unsplash.com/photo-1777136977034-71cbc026c9b1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDN8MHwxfHNlYXJjaHwyfHxyZXRhaWwlMjBzdG9yZSUyMGludGVyaW9yfGVufDB8fHx8MTc4NDI1MTQ0NHww&ixlib=rb-4.1.0&q=85",
    year: "2024",
    area: "1,800 sq ft"
  },
  {
    id: 8,
    title: "Luxury Lifestyle Store",
    titleChinese: "奢華生活方式店",
    category: "retail",
    description: "Upscale retail environment featuring warm materials, curated displays, and an inviting atmosphere.",
    descriptionChinese: "高檔零售環境，採用溫暖的材料、精心策劃的展示和溫馨的氛圍。",
    image: "https://images.unsplash.com/photo-1777628530456-bb93d3a03faf?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDN8MHwxfHNlYXJjaHwzfHxyZXRhaWwlMjBzdG9yZSUyMGludGVyaW9yfGVufDB8fHx8MTc4NDI1MTQ0NHww&ixlib=rb-4.1.0&q=85",
    year: "2023",
    area: "2,200 sq ft"
  },
  {
    id: 9,
    title: "PICKLEBALL COURT",
    titleChinese: "PICKLEBALL COURT",
    category: "pickleball",
    description: "State-of-the-art indoor pickleball court with professional-grade playing surface and modern amenities.",
    descriptionChinese: "最先進的室內匹克球場，配備專業級競賽場地與現代化設施。",
    image: "https://images.unsplash.com/photo-1761644518970-2ed0ab543e1b?fm=jpg&q=60&w=3000&auto=format&fit=crop&ixlib=rb-4.1.0",
    year: "2024",
    area: "5,000 sq ft"
  },
  {
    id: 10,
    title: "Premium Fitness Hub",
    titleChinese: "優質健身中心",
    category: "pickleball",
    description: "Dynamic sports and fitness facility designed to inspire active lifestyles with cutting-edge equipment.",
    descriptionChinese: "充滿活力的運動和健身設施，旨在通過尖端設備激發積極的生活方式。",
    image: "https://images.unsplash.com/photo-1689877020200-403d8542d95d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTJ8MHwxfHNlYXJjaHw0fHxtb2Rlcm4lMjBneW18ZW58MHx8fHwxNzg0MjUxNDc5fDA&ixlib=rb-4.1.0&q=85",
    year: "2023",
    area: "4,200 sq ft"
  }
];

export const manifesto = [
  {
    number: "01",
    title: "Design Excellence",
    titleChinese: "設計卓越",
    content: "We believe exceptional design transforms not just spaces, but the lives within them. Through precise listening and deep analysis, we decode your daily life patterns and business mechanisms to create spaces that perfectly align with your vision.",
    contentChinese: "我們相信卓越的設計不僅能改變空間，更能改變其中的生活。通過精準聆聽與深度剖析，我們解構您的日常軌跡與商業機制，創造完美契合您願景的空間。"
  },
  {
    number: "02",
    title: "Details Matter",
    titleChinese: "細節至上",
    content: "Every dot has a story. From the 1mm precision of stone-metal junctions to the perfect damping feel of hardware, we scrutinize every detail with meticulous standards. True luxury is built from countless perfect micro-elements.",
    contentChinese: "點點點都有態度。從石材與金屬交接的 1mm 精密收口，到五金扣件的完美阻尼觸感，我們以極苛標準審視每一處細節。真正的高級感源於無數完美的微小元素。"
  },
  {
    number: "03",
    title: "Timeless Design",
    titleChinese: "雋永經典",
    content: "We resist fleeting trends and fast-consumption aesthetics. By focusing on proportion, light-shadow interplay, and the golden ratio of natural materials, we create spaces with enduring elegance that transcends time.",
    contentChinese: "我們拒絕追逐一時的流行風潮與快消式美學。聚焦比例、光影與自然材質的黃金配比，創造具備生命力、超越時光的雋永優雅空間。"
  },
  {
    number: "04",
    title: "100% Transparency",
    titleChinese: "極致透明",
    content: "We pioneer the 'All-Transparent Engineering System' with 100% material traceability, seamless quotation comparison, and daily cloud-visible progress. Contract budget equals final cost—no hidden charges, ever.",
    contentChinese: "我們首創「全方位明牌工程體系」，100% 材料品牌溯源、無縫報價對比、工程進度雲端可視。合同預算即最終造價，堅決不打任何追加預算的擦邊球。"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Sarah Chen",
    nameChinese: "陳小姐",
    company: "Tech Innovation Ltd",
    companyChinese: "科技創新有限公司",
    role: "CEO",
    content: "ddt interiors transformed our office into a space that truly reflects our company culture. The attention to detail and innovative approach exceeded all expectations.",
    contentChinese: "點點點設計將我們的辦公室改造成真正反映我們公司文化的空間。對細節的關注和創新方法超出了所有期望。",
    rating: 5
  },
  {
    id: 2,
    name: "Dr. Michael Wong",
    nameChinese: "黃醫生",
    company: "Central Medical Clinic",
    companyChinese: "中環醫療診所",
    role: "Medical Director",
    content: "The clinic design creates a calming environment for our patients while maintaining the highest standards of functionality. Truly exceptional work.",
    contentChinese: "診所設計為我們的患者創造了一個寧靜的環境，同時保持了最高標準的功能性。真正出色的工作。",
    rating: 5
  },
  {
    id: 3,
    name: "Emily Leung",
    nameChinese: "梁小姐",
    company: "Luxe Beauty Salon",
    companyChinese: "奢華美容沙龍",
    role: "Owner",
    content: "Our clients constantly compliment the elegant and luxurious atmosphere. ddt interiors understood our vision perfectly and brought it to life.",
    contentChinese: "我們的客戶經常稱讚優雅奢華的氛圍。點點點設計完美理解了我們的願景並將其變為現實。",
    rating: 5
  }
];
